const type = 'API_KEY';

export const FETCH_API_KEYS_REQUEST = `${type}/FETCH_${type}S_REQUEST`;
export const FETCH_API_KEYS_RESPONSE = `${type}/FETCH_${type}S_RESPONSE`;

export const FETCH_API_KEY_TYPES_REQUEST = `${type}/FETCH_${type}_TYPES_REQUEST`;
export const FETCH_API_KEY_TYPES_RESPONSE = `${type}/FETCH_${type}_TYPES_RESPONSE`;

export const SET_API_KEY_ERRORS = `${type}/SET_${type}_ERROR`;
